import { schema } from "normalizr";

const assignee = new schema.Entity(`assignees`);
const arrayOfAssignees = [assignee];

export { assignee, arrayOfAssignees };
